export default __webpack_public_path__ + "static/dsta20182-8acac912982e960f37dc6a8f557e4d4a.jpg";